import { Events, ParsedEvents } from './utils';

export enum EventsStatusEnum {
  GET_EVENTS = 'events/get',
}

export interface BaseEvens {
  err_code: number;
  success: boolean;
  filtered: string;
  page: number;
  limit: number;
  token: string;
}

export interface EventsData extends BaseEvens {
  data: Events;
}

export interface PromiseEventsData extends BaseEvens {
  data: ParsedEvents;
}



// WEBPACK FOOTER //
// ./src/services/api/events/types.ts